import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { z } from "zod";
import { ensureElementVisible } from "@/lib/route-guards";

const ZwrotyDziennePage = lazy(() => import("@/features/reports/zwroty-dzienne-page"));

// Jak w odchylenia-cen-fv (FARMASTER-FRONTEND-33/34): zly `date` w URL (stary
// bookmark, reczna edycja) nie moze crashowac trasy ZodErrorem w validateSearch.
// `.catch(undefined)` = traktuj niepoprawny param jak brak → default (dzis).
const isoDate = z
	.string()
	.regex(/^\d{4}-\d{2}-\d{2}$/)
	.optional()
	.catch(undefined);

const searchSchema = z.object({
	scope: z.string().optional(),
	date: isoDate,
	rodzaj: z.enum(["OTC", "RX", "RX100", "BD"]).optional().catch(undefined),
});

export type ZwrotyDzienneSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/raporty/zwroty-dzienne")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.zwroty-dzienne",
			location.pathname,
		);
	},
	component: ZwrotyDziennePage,
	validateSearch: (search: Record<string, unknown>): ZwrotyDzienneSearch =>
		searchSchema.parse(search),
});
